import React, { FunctionComponent } from 'react';
import type { RecruitmentShowApplicationsBrandsProps } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowApplicationsBrandsProps & {
  applications: Recruitment[];
  brandId: string;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  noimage,
  title,
  isStopped,
  dataCategory,
  dataValue,
  applications,
  brandId,
  isPreview
}) => {
  if (applications.length === 0) return null

  return (
    <div className={`recruitment__show__content recruitment__show__company ${isStopped ? 'is-stopped' : ''}`} id="brand-recruitments-section">
      <h3 className="mainTitle">
        {title}
        <a
          className="link gtm-button-view-count"
          href={`/brands/${brandId}`}
          {...(!isPreview && {
            'data-event-name': 'button on screen',
            'data-event': 'click',
            'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
            'data-value': dataValue.moreBrandRecruitments
          })}
        >
          もっと見る
        </a>
      </h3>

      <div className="recruitment__show__applications__slider js-recruitment-applications-brands">
        {applications.map(application => (
          <a
            key={application.id}
            href={`/recruitments/${application.id}`}
            className={`box ${!isPreview ? 'gtm-recruitment-view-count' : ''}`}
            target="_blank"
            rel="noopener noreferrer"
            {...(!isPreview && {
              'data-event-name': 'recruitments on screen',
              'data-event': 'click',
              'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
              'data-value': dataValue.relatedBrandRecruitments,
              'data-recruitmentid': application.id,
              'data-companyid': application.companyId
            })}
          >
            {application.image.url !== null ? (
              <img src={application.image.url} alt={`${application.title}の画像`} />
            ) : (
              <img src={noimage} alt={`${application.title}の画像`} />
            )}
            <p className="title">
              <span className="occupation">{application.title}</span>
              <span className="prefecture">{application.prefecture}</span>
            </p>
            <p className="body">{application.body}</p>
          </a>
        ))}
      </div>
    </div>
  );
};
